import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Card, PageHeader, Button, Empty, Spin } from 'antd'
import useSWR from 'swr'
import { useSnapshot } from 'valtio'

import tableStore from '../../lib/store/scanner_table'
import ScannerService from '../../network/services/scanner'
import { serialize } from '../../network/request'
import ScannerTable from './ScannerTable'

const ScannerPage = () => {
  const navigate = useNavigate()
  const primaryAction = (
    <Button
      key="add"
      type="primary"
      onClick={() => {
        navigate('new')
      }}
    >
      Create Scanner
    </Button>
  )

  return (
    <PageHeader title="All Scanners" extra={[primaryAction]}>
      <Card>
        <ScannerTableWrapper />
      </Card>
    </PageHeader>
  )
}

const ScannerTableWrapper = () => {
  const { state } = useSnapshot(tableStore)

  // use this to preload
  const { data: response, error } = useSWR(
    serialize(ScannerService.getAll, { page: 1, limit: state.pageSize, ...state.filters })
  )

  if (error) {
    console.log(error)
    return <Empty description={error?.message ?? 'Please try again later'} />
  }

  console.log(response)

  if (!response) {
    return <Spin />
  }

  const { total } = ScannerService.toPaginate(response)

  return (
    <>
      <ScannerTable total={total} />
      {/* preload next page */}
      {state.currentPage * state.pageSize < total && (
        <div style={{ display: 'none' }}>
          <ScannerTable total={total} overridePage={state.currentPage + 1} />
        </div>
      )}
    </>
  )
}

export default ScannerPage
